import * as React from "react";
import { ProteinControllerApi, ProteinResponse } from "../../../api/openapi-generator";
import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import { getApiUrl } from "../../../api";

interface Props {
  targets: ProteinResponse[],
}

function KnownTargetImagePrefetch({targets}: Props) {

  const [urlFormat, setUrlFormat] = useState<string | null>(null);
  useEffect(() => {
    getApiUrl(ProteinControllerApi, 'imageRaw', {codeAscii: '{0}', topologicalDomain: '{1}'})
      .then(decodeURI)
      .then(setUrlFormat);
  }, []);

  return (
    urlFormat !== null ? (
      <Helmet>
        {targets.flatMap(({domains, codeAscii}) => (domains ?? []).map(domain => {
          const url = urlFormat.replace('{0}', codeAscii).replace('{1}', domain);
          return <link key={`${codeAscii}_${domain}`} rel="prefetch" href={url} as="image"/>
        }))}
      </Helmet>
    ) : null
  )
}

export default KnownTargetImagePrefetch;
